import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

export const StyledSwiper = styled(Swiper)<{
  $hideNavigation: boolean;
  separator: string;
}>`
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  .swiper {
    ${({ $hideNavigation, separator, theme }) => css`
      ${$hideNavigation &&
      css`
        &-button-prev,
        &-button-next {
          display: none;
        }
      `}
      &-slide {
        ${theme.media.md.up} {
          &-visible {
            ::before {
              content: '';
              position: absolute;
              height: 130px;
              left: -55px;
              top: 35%;
              transform: translateY(-35%);
              width: 0;
              background-color: ${theme.colors.defaultAdd5};
              display: ${separator === 'true' ? 'block' : 'none'};

              &:nth-child(n + 1) {
                width: 20px;
              }
            }

            ${theme.media.lg.up} {
              ::before {
                top: 32%;
                right: -60px;
                height: 140px;
              }
            }
          }

          &-active::before {
            display: none;
          }
        }
      }

      &-scrollbar {
        background: ${theme.colors.mediumGrey};
        height: 2px;
        bottom: 14px;
        left: 0;
        width: 100%;
        &-drag {
          background: ${theme.colors.navyBlue};
        }
      }
    `}
  }
`;

export const Navigation = styled.span<{ type: 'next' | 'prev' }>`
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: all;
  background: transparent;
  ${({ theme, type }) => css`
    padding: ${theme.spacing(2)};
    ${type === 'next' ? 'right' : 'left'}: 0px;
    ${theme.media.md.down} {
      ${type === 'next' ? 'right' : 'left'}: 0px;
    }
  `}

  :hover {
    cursor: pointer;
  }

  svg {
    height: 24px;

    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  &.swiper-button {
    &-disabled {
      display: none;
      svg path {
        fill: ${({ theme }) => theme.colors.defaultAdd4};
      }
      &:hover {
        cursor: not-allowed;
      }
    }
  }
`;
